import { createApiRef } from '@backstage/core-plugin-api';

export type ApiResponse<T> = {
  meta: any;
  data: T[];
};

export type Group = {
  id: string;
  name: string;
  displayName: string;
  members: { id: string }[];
};

export type User = {
  github: {
    userName?: string;
  };
  id: string;
  userName: string;
  userNameShort: string;
  displayName: string;
  firstName: string;
  lastName: string;
  email: string;
};

export type FetchOpts = {
  limit?: number;
  offset?: number;
};

export interface DevPortalOrgHubApi {
  fetchGroups(opts?: FetchOpts): Promise<Group[]>;
  fetchUsers(opts?: FetchOpts): Promise<User[]>;
}

export const devPortalOrgHubApiRef = createApiRef<DevPortalOrgHubApi>({
  id: 'plugin.dev-portal-org-hub.api',
});
